<template>
  <div class="h-full">
    <router-view name="subnav"></router-view>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'LocalizationPage'
}
</script>
